module.exports = vendor_5c498da6d3df50cae97a;